import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgOtpInputModule } from 'ng-otp-input';

import { FullCalendarModule } from "@fullcalendar/angular";
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin
import interactionPlugin from "@fullcalendar/interaction"; // a plugin
import {
  NgbAccordionModule,
  NgbCollapseModule,
  NgbDropdownModule,
  NgbModalModule,
  NgbModule,
  NgbNavModule,
  NgbPopoverModule,
  NgbTooltipModule,
} from "@ng-bootstrap/ng-bootstrap";
import { NgApexchartsModule } from "ng-apexcharts";
import { LightboxModule } from "ngx-lightbox";
import { CarouselModule } from "ngx-owl-carousel-o";
import { SimplebarAngularModule } from "simplebar-angular";
import { UIModule } from "../shared/ui/ui.module";
import { WidgetModule } from "../shared/widget/widget.module";

// Emoji Picker
import { PickerModule } from "@ctrl/ngx-emoji-mart";

import { PagesRoutingModule } from "./pages-routing.module";


import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
// import { CoursesComponent } from './menu/courses/courses.component';
import { Daterangepicker } from "ng2-daterangepicker";
// import { OnlinestoreComponent } from './onlinestore/onlinestore.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { MatSelectInfiniteScrollModule } from 'ng-mat-select-infinite-scroll';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CoreModule } from '../core/core.module';
import { PriceComparisonComponent } from './al/price-comparison/price-comparison.component';
// import { EmployeeSupportPinComponent } from './employee-support-pin/employee-support-pin.component';
import { UiSwitchModule } from "ngx-ui-switch";
import { EventRecommendationsComponent } from './event-recommendations/event-recommendations.component';
import { MarketingComponent } from './marketing/marketing.component';
import { NewHomePageComponent } from "./marketing/new-home-page/new-home-page.component";
import { MerchantsModule } from './merchants/merchants.module';
import { Page403Component } from './page403/page403.component';
import { PlanPricingComponent } from "./plan-pricing/plan-pricing.component";
import { ProductmanagmentComponent } from './productmanagment/productmanagment.component';
import { ProfileSettingsComponent } from "./profile-settings/profile-settings.component";
import { ReportsComponent } from './reports/reports.component';
import { SitesComponent } from './sites/sites.component';
import { StarterModule } from './starter/starter.module';
import { OverviewComponent } from './subscription/overview/overview.component';
import { SubBillingComponent } from './subscription/sub-billing/sub-billing.component';
import { SubManageComponent } from './subscription/sub-manage/sub-manage.component';
import { EditsupportticketsComponent } from './support-tickets/editsupporttickets/editsupporttickets.component';
import { SupportTicketsComponent } from './support-tickets/support-tickets.component';
import { AddsuppportTicketsMerchantComponent } from './suppportticketsmerchant/addsuppportticketsmerchant/addsuppportticketsmerchant.component';
import { EditsuppportTicketsMerchantComponent } from './suppportticketsmerchant/editsuppportticketsmerchant/editsuppportticketsmerchant.component';
import { SuppportTicketsMerchantComponent } from './suppportticketsmerchant/suppportticketsmerchant.component';
// import { NetwokSummeryComponent } from "./starter/network-summery/network-summery.component";


FullCalendarModule.registerPlugins([
  // register FullCalendar plugins
  dayGridPlugin,
  interactionPlugin,
]);

@NgModule({
  declarations: [
    ProfileSettingsComponent,
    ReportsComponent,
    SitesComponent,
    Page403Component,
    OverviewComponent,
    SubManageComponent,
    SubBillingComponent,
    PriceComparisonComponent,
    ProductmanagmentComponent,
    MarketingComponent,
    // EmployeeSupportPinComponent,
    NewHomePageComponent,
    SupportTicketsComponent,
    EditsupportticketsComponent,
    SuppportTicketsMerchantComponent,
    AddsuppportTicketsMerchantComponent,
    EditsuppportTicketsMerchantComponent,
    PlanPricingComponent,
    EventRecommendationsComponent
    // NetwokSummeryComponent,
  ],

  imports: [
    CarouselModule,
    NgbAccordionModule,
    CommonModule,
    FormsModule,
    CKEditorModule,
    NgbDropdownModule,
    NgbModalModule,
    NgbNavModule,
    PagesRoutingModule,
    NgApexchartsModule,
    ReactiveFormsModule,
    // HttpClientModule,
    UIModule,
    WidgetModule,
    FullCalendarModule,
    NgbTooltipModule,
    NgbCollapseModule,
    SimplebarAngularModule,
    LightboxModule,
    PickerModule,
    NgxIntlTelInputModule,
    NgxDaterangepickerMd.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    NgxDropzoneModule,
    Daterangepicker,
    NgbPopoverModule,
    MerchantsModule,
    NgOtpInputModule,
    StarterModule,
    CoreModule,
    NgSelectModule,
    DataTablesModule,
    CurrencyMaskModule,
    DragDropModule,
    MatSelectModule,
    MatFormFieldModule,
    NgxMatSelectSearchModule,
    MatSelectInfiniteScrollModule,
    // AgmCoreModule.forRoot({
    //   apiKey: environment.googleApiKey,
    //   libraries: ["places"],
    // }),
    NgbModule,
    Ng2SearchPipeModule,
    UiSwitchModule
  ]
})
export class PagesModule { }
